module.exports = __webpack_public_path__ + "static/media/placeholder_7.cd5457d4.jpg";